import React, { Dispatch, useCallback, useEffect, useState } from "react";
import { UserData } from "@sms/shared/users/users.interface";
import { useDispatch, useSelector } from "react-redux";

import styles from "./auth.module.scss";
import { AuthComponentProps, AuthState } from "./auth.types";

import { ApplicationStore } from "~/app/application.store";
import { authenticate, handleRunCheckIsAuthAction, setUserAuthDataAction } from "~/app/auth/auth.actions";

const AuthComponent: React.FC<AuthComponentProps> = (props: AuthComponentProps) => {
  const dispatch: Dispatch<any> = useDispatch();

  const user: UserData | null = useSelector((state: ApplicationStore) => state.auth.user);
  const isAuth: boolean | null = useSelector((state: ApplicationStore) => state.auth.isAuth);
  const [auth, setAuth]: [AuthState, React.Dispatch<React.SetStateAction<AuthState>>] = useState<AuthState>({
    login: "",
    password: ""
  });

  const handleRunCheckIsAuth: () => void = useCallback(() => {
    dispatch(handleRunCheckIsAuthAction());
  }, [dispatch]);
  const setUserAuthData: (authData: AuthState) => void = useCallback(
    (authData: AuthState): void => {
      dispatch(setUserAuthDataAction(authData));
    },
    [dispatch]
  );
  const handleAuthenticate: () => void = useCallback(() => {
    dispatch(authenticate());
  }, [dispatch]);

  useEffect(() => {
    handleRunCheckIsAuth();
  }, []);

  const handleChange: (target: { name: string; value: string }) => void = (target: {
    name: string;
    value: string;
  }): void => {
    setAuth({ ...auth, [target.name]: target.value });
  };

  const handleSubmit: (e: React.FormEvent<HTMLFormElement>) => void = (e: React.FormEvent<HTMLFormElement>): void => {
    e.preventDefault();
    setUserAuthData(auth);
    handleAuthenticate();
  };

  if (isAuth === null) {
    return <></>;
  }

  if (user === null && isAuth === false) {
    return (
      <div className={styles.authWrap}>
        <h2>Login</h2>
        <form onSubmit={handleSubmit}>
          <input name="login" onChange={(e): void => handleChange(e.target)} placeholder="Login" />
          <input
            type="password"
            name="password"
            onChange={(e): void => handleChange(e.target)}
            placeholder="Password"
          />
          <button>Login</button>
        </form>
      </div>
    );
  }
  return <>{props.children}</>;
};

export default AuthComponent;
